import { useDebounce } from 'ahooks';
import { useQuery } from '@tanstack/react-query';
import commonService from 'common/service';

export const useAllRelationGames = ({ query, enabled = true }) => {
  const queryDebounce = useDebounce(query, { wait: 250 });
  return useQuery(
    ['getGameList', queryDebounce],
    async () => {
      try {
        const data = await commonService.artist.getGameList({
          name: queryDebounce,
        });

        // format to value and label record list
        const formattedGameList = data?.items.map((item) => {
          return { value: item.id, label: item.name };
        });
        return formattedGameList;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    {
      enabled: enabled,
      cacheTime: 300000, // 默认5分钟内不发起新的请求，直接使用缓存
    },
  );
};
